<template>
  <div v-zpm="{ sectionid: 161 }" class="trust-wrapper">
    <div class="trust-content" :class="{ other_env: !env }">
      <div
        v-zpm="{ sortname: '同款评价', sortid: 2 }"
        @click="skipToUrl({ targetUrl: ratingMsg[0].ratingurl })"
        v-if="ratingMsg && ratingMsg.length"
      >
        <div class="common-title">
          <span class="title-main">同款评价</span>
          <span v-if="state.satisfactionRate" class="title-sub">{{ state.satisfactionRate }}</span>
          <span v-if="state.orderEvaluateNum" class="title-sub">
            {{ state.orderEvaluateNum }}条评价</span
          >
        </div>

        <div v-if="ratingMsg && ratingMsg.length" class="user-wrapper">
          <div v-for="item in ratingMsg" :key="item.nickName">
            <div class="avatar">
              <img :src="$setPicSize(item.avator, 36, 36)" alt="" />
              <span class="name">{{ item.nickname }}</span>
            </div>
            <span class="comment" :class="{ 'pic-comment': zcshowImg.length }">{{
              item.content
            }}</span>
          </div>
          <!-- 图片内容为仅有评价没有种草秀展示 -->
          <div v-if="!zcshowImg.length" class="comment-picture-list">
            <div v-for="(imgItem, imgIndex) in pictureList" :key="imgIndex + 1" class="li_imgArr">
              <render-image
                lazy-load
                fit="cover"
                :src="$setPicSize(imgItem, 224)"
                class="pic-img"
                alt=""
              ></render-image>
            </div>
          </div>
        </div>
      </div>

      <div class="common-title">
        <div
          v-if="zcshowImg && zcshowImg.length > 0"
          v-zpm="{ sortname: '种草秀', sortid: 3 }"
          class="zc-wrapper"
          :class="{ 'zc-wrapper-five': imgListLen >= 5 && imgListLen < 8 && !ratingMsg.length }"
          @click="skipToUrl({ targetUrl: zcShowMsg.zcshowUrl })"
        >
          <div class="zc-wrapper__header">
            <span class="title-main">种草秀</span>
            <span class="title-sub">{{ zcShowMsg.numText }}条种草秀帖子</span>
          </div>
          <div class="img-list">
            <!-- 种草秀图片分为三种样式 分别为数量2 5 8 小于2个则不展示-->
            <template v-if="imgListLen >= 8 || ratingMsg.length">
              <div :class="{ 'img-list-eight': ratingMsg.length == 0 }">
                <img
                  v-for="(item, index) in normalImgList"
                  :key="index"
                  class="img-item"
                  :class="{
                    'img-big-item': ratingMsg.length == 0,
                    'img-normal-item': ratingMsg.length
                  }"
                  :src="$setPicSize(item.materialInfos[0].materialUrl, 120, 120)"
                  alt=""
                />
              </div>
            </template>

            <template v-if="imgListLen >= 2 && imgListLen < 5">
              <div class="img-list-two">
                <img
                  v-for="(item, index) in imgList.slice(0, 2)"
                  :key="index"
                  class="img-item-two"
                  :src="$setPicSize(item.materialInfos[0].materialUrl)"
                  alt=""
                />
              </div>
            </template>

            <template v-if="imgListLen >= 5 && imgListLen < 8">
              <div class="img-list-five">
                <div class="img-left">
                  <img
                    class="img-item-left"
                    :src="$setPicSize(imgList[0].materialInfos[0].materialUrl)"
                    alt=""
                  />
                </div>
                <div class="img-right">
                  <img
                    v-for="(item, index) in imgList.slice(1, 5)"
                    :key="index"
                    class="img-item-right"
                    :src="$setPicSize(item.materialInfos[0].materialUrl)"
                    alt=""
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="jump-content">
          <div
            v-if="ratingMsg && ratingMsg.length"
            v-zpm="{ sortname: '查看全部评价', sortid: 0 }"
            class="jump-detail"
            @click="skipToUrl({ targetUrl: ratingMsg[0].ratingurl })"
          >
            查看全部评价

            <img
              :src="
                $setPicSize(
                  'https://pic4.zhuanstatic.com/zhuanzh/db095ccb-6d8a-41e3-b14f-ad4b41c176c9.png'
                )
              "
              alt=""
            />
          </div>
          <div
            v-if="zcshowImg && zcshowImg.length > 0 && ratingMsg && ratingMsg.length"
            class="line"
          ></div>
          <div
            v-if="zcshowImg && zcshowImg.length > 0"
            v-zpm="{ sortname: '查看种草秀', sortid: 1 }"
            class="jump-detail"
            @click="skipToUrl({ targetUrl: zcShowMsg.zcshowUrl })"
          >
            <span :class="{ 'andorid-text': !isIOS }">查看种草秀</span>
            <img
              :src="
                $setPicSize(
                  'https://pic4.zhuanstatic.com/zhuanzh/db095ccb-6d8a-41e3-b14f-ad4b41c176c9.png'
                )
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, watch } from '@vue/composition-api'
import { state } from '@/store'
import { skipToUrl, isPlatform } from '@utils/native'
import { isIOS } from '@utils/index'
export default defineComponent({
  setup() {
    const env = isPlatform('zz')
    const listData = ref([])

    const pictureList = computed(() => {
      if (listData.value) {
        return listData.value[0].pictureList
      }
      return []
    })

    const ratingMsg = computed(() => {
      if (state?.rating?.length) {
        const useData = state.rating.slice(0, 1)
        const data = useData.map((item) => {
          return {
            nickname: item.evaluator.nickName,
            avator: item.evaluator.profilePicture,
            content: item.content,
            ratingurl: state?.evalListData?.clickUrl || ''
          }
        })
        return data
      }

      return []
    })

    const zcShowMsg = computed(() => {
      return {
        zcshowUrl: state?.zcShowListData?.clickUrl + '&packageId=' + state.packageId || '',
        numText: state?.zcShowListData?.numText || ''
      }
    })

    const zcshowImg = computed(() => {
      return state?.zcShowListData?.evaluationInfos?.reduce((pre, cur) => {
        const materialUrl = cur.materialInfos.map((item) => {
          if (item.type == 1) {
            return item.materialUrl
          }
          return ''
        })
        return [...pre, ...materialUrl].filter(Boolean) || []
      }, [])
    })

    const zcDynamicShowImg = computed(() => {
      return state?.zcShowListData?.evaluationInfos?.reduce((pre, cur) => {
        const materialUrl = cur.materialInfos.map((item) => {
          if (item.type == 1) {
            return item.materialUrl
          }
          return ''
        })
        if (ratingMsg.value.length) {
          return [...pre, ...materialUrl].filter(Boolean).slice(0, 4) || []
        } else {
          return [...pre, ...materialUrl].filter(Boolean).slice(0, 8) || []
        }
      }, [])
    })

    const imgList = computed(() => {
      const evaluationInfos = state?.zcShowListData?.evaluationInfos || []
      if (evaluationInfos) {
        evaluationInfos.forEach((item) => {
          const { materialInfos } = item
          materialInfos.forEach((val) => {
            if (val.type == 2) {
              if (val.materialUrl?.indexOf('cdn.huodao.hk') !== -1) {
                val.materialUrl = `${val.materialUrl}${
                  val.materialUrl.indexOf('?') === -1
                    ? '?x-oss-process=video/snapshot,t_10000,f_jpg,m_fast,ar_auto'
                    : '&x-oss-process=video/snapshot,t_10000,f_jpg,m_fast,ar_auto'
                }`
              }
            }
          })
          // 克隆一个数组 避免引发vue的重复渲染
          item.materialInfos = item.materialInfos.slice().sort((a, b) => {
            return b.type - a.type
          })
        })
      }
      return evaluationInfos || []
    })

    const normalImgList = computed(() => {
      if (ratingMsg.value.length) {
        return imgList.value.slice(0, 4)
      } else {
        return imgList.value.slice(0, 8)
      }
    })

    const imgListLen = computed(() => {
      if (imgList.value) {
        return imgList.value.length
      }
      return 0
    })

    watch(
      () => state.evalListData,
      (newVal) => {
        listData.value = newVal?.dataList?.length ? newVal.dataList.slice(0, 1) : []
      },
      {
        immediate: true,
        deep: true
      }
    )

    console.log(isIOS, 'isIOS')

    return {
      state,
      ratingMsg,
      zcShowMsg,
      zcDynamicShowImg,
      skipToUrl,
      isIOS,
      zcshowImg,
      isPlatform,
      listData,
      pictureList,
      imgList,
      imgListLen,
      normalImgList,
      env
    }
  }
})
</script>

<style lang="scss" scoped>
.trust-wrapper {
  position: relative;
  width: 100%;
  height: 100vw;
  background: #f8f8f8f8;

  .trust-content {
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 686px;
    height: 482px;
    margin-bottom: 80px;
    margin-left: 32px;
    padding: 32px;
    background: #fff;

    border-radius: 16px;
    &.other_env {
      margin-bottom: 165px;
    }
    .common-title {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 1;

      .zc-wrapper {
        margin-bottom: 32px;
        &__header {
          display: flex;
          align-items: center;
        }
      }
      .zc-wrapper-five {
        margin-bottom: 26px;
      }
      .title-main {
        color: #000000;
        font-weight: 400;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        // line-height: 28px;
      }
      .title-sub {
        margin-left: 12px;
        color: #999999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        // line-height: 20px;
      }
      .img-list {
        display: flex;
        // width: 100%;
        margin-top: 16px;
        flex-wrap: wrap;

        .img-item {
          width: 120px;
          height: 120px;
          margin-right: 8px;
        }
        .img-list-two {
          display: flex;
        }
        .img-item-two {
          width: 307px;
          height: 307px;
          margin-right: 7px;

          &:first-child {
            border-radius: 12px 0 0 12px;
          }
          &:last-child {
            border-radius: 0 12px 12px 0;
          }
        }
        .img-list-five {
          display: flex;
          padding-top: 7px;
        }
        .img-item-left {
          width: 307px;
          height: 307px;
          margin-right: 8px;
          border-radius: 12px 0 0 12px;
        }
        .img-item-right {
          width: 149px;
          height: 149px;
          margin-right: 8px;
          padding-bottom: 5px;

          &:nth-child(2n) {
            margin-right: 0;
          }
          &:nth-child(2) {
            border-radius: 0 12px 0 0;
          }
          &:last-child {
            border-radius: 0 0 12px;
          }
        }
        .img-normal-item {
          border-radius: 12px;
        }
        .img-list-eight {
          margin-top: 3px;
        }
        .img-big-item {
          width: 149px;
          height: 149px;
          margin-right: 8px;
          margin-top: 5px;

          &:first-child {
            border-radius: 12px 0 0;
          }

          &:last-child {
            border-radius: 0 0 12px;
          }

          &:nth-child(4) {
            border-radius: 0 12px 0 0;
          }

          &:nth-child(5) {
            border-radius: 0 0 0 12px;
          }

          &:nth-child(4n) {
            margin-right: 0;
            // border-radius: 0 12px 0 0;
          }
        }
      }

      .jump-content {
        display: flex;
        justify-content: center;
        width: 100%;

        .jump-detail {
          display: flex;
          align-items: center;
          color: #000000;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 22px;
          .andorid-text {
            position: relative;
            top: -1px;
          }
          img {
            position: relative;
            top: 0;
            width: 24px;
            height: 24px;
            margin-top: -1px;
            margin-left: 4px;
          }
        }
        .line {
          position: relative;
          width: 1px;
          height: 16px;
          margin: 0 28px;
          margin-top: 3px;
          &::after {
            position: absolute;
            top: 50%;
            left: 0;
            width: 1px;
            height: 16px;
            background: #c6c6c6;
            transform: translateY(-50%) scaleX(0.5);
            content: '';
          }
        }
      }
    }

    .user-wrapper {
      .hidden:last-child {
        display: none;
      }
    }
    .avatar {
      display: flex;
      align-items: center;
      margin-top: 25px;
      margin-bottom: 21px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .name {
        margin-left: 12px;
        color: #999999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 20px;
      }
    }
    .comment {
      @include overflowLine(3);
      margin-top: 8px;
      color: #000000;
      font-weight: 300;
      font-size: 24px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 36px;
    }
    .pic-comment {
      @include overflowLine(2);
      margin-bottom: 30px;
    }

    .comment-picture-list {
      margin-top: 20px;
      margin-bottom: 32px;
      display: flex;

      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      border-bottom-left-radius: 12px;

      .li_imgArr {
        margin-right: 8px;
        width: 120px;
        height: 120px;
      }
      .li_imgArr:first-child {
        /deep/ img {
          border-radius: 12px 0 0 12px !important;
        }
      }
      .li_imgArr:last-child {
        /deep/ img {
          border-radius: 0 12px 12px 0 !important;
        }
      }
    }
  }
}
</style>
